export default __webpack_public_path__ + "static/media/UGA.0fa92ef1.svg";